import dayjs from 'dayjs'
import rt from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/zh-cn'
import store from '@/store'
dayjs.extend(rt)
const dateFilter = (date, fmt = 'YYYY-MM-DD') => {
  if (!isNaN(date)) {
    date = parseInt(date) // 转换成数字
  }
  return dayjs(date).format(fmt)
}

// 多少时间之前
export const relativeTime = (date) => {
  if (!isNaN(date)) {
    date = parseInt(date) // 转换成数字
  }
  // 现在时间 相对传过来的时间 多少时间
  // 表示目标时间相对于现在，是多久以前或多久以后
  // 当前时间.to(目标时间)
  return dayjs().locale(store.getters.language === 'zh' ? 'zh-cn' : 'en').to(dayjs(date))
}
// 挂载全局属性
export default app => {
  app.config.globalProperties.$filters = {
    dateFilter,
    relativeTime
  }
}
